module.exports = __webpack_public_path__ + "img/02_content_01.1ad3f661.png";